// Shared helpers for lead-form campaign LPs (Canton Fair, Luxury Honeymoon, etc.)
// - Robust phone normalization (handles +91, 91 prefix, leading 0, spaces, dashes)
// - Mobile-friendly WhatsApp deep-link opener (uses wa.me + same-tab nav on mobile
//   so the WhatsApp app opens cleanly instead of a browser chooser dialog)

// Normalise an Indian mobile input to a bare 10-digit number.
// Accepts: "+91 78883 70003", "91-78883-70003", "078883 70003", "78883-70003" → "7888370003"
// Returns "" for invalid/short input so callers can gate on it.
export function normalizeIndianPhone(raw) {
  if (!raw) return "";
  let d = String(raw).replace(/\D/g, "");
  // Strip country code / IDD prefixes
  if (d.startsWith("0091")) d = d.slice(4);
  else if (d.startsWith("91") && d.length > 10) d = d.slice(2);
  // Strip a single leading zero (STD prefix)
  if (d.startsWith("0") && d.length > 10) d = d.slice(1);
  else if (d.length === 11 && d.startsWith("0")) d = d.slice(1);
  // Cap at 10 (defensive — after stripping should be exactly 10)
  d = d.slice(0, 10);
  return d;
}

// Detect mobile user-agent for choosing WhatsApp open strategy.
export function isMobileUA() {
  if (typeof navigator === "undefined") return false;
  return /Android|iPhone|iPad|iPod|Opera Mini|Mobile/i.test(navigator.userAgent || "");
}

// Open a WhatsApp chat cleanly on all devices.
// Mobile → wa.me + location.href (opens WhatsApp app directly, no chooser dialog)
// Desktop → api.whatsapp.com/send in a new tab (opens WhatsApp Web/Desktop)
export function openWhatsApp(phone, message = "") {
  const digits = String(phone || "").replace(/\D/g, "");
  const text = encodeURIComponent(message);
  if (isMobileUA()) {
    // wa.me is the canonical universal-link — opens the app on Android/iOS
    // without showing the "Open with" chooser we saw on desktop.
    const url = `https://wa.me/${digits}?text=${text}`;
    window.location.href = url;
    return url;
  }
  const url = `https://api.whatsapp.com/send?phone=${digits}&text=${text}`;
  window.open(url, "_blank", "noopener");
  return url;
}
